import React, { useState, useEffect } from 'react';
import { Pill, Typography } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { CONSTANTS } from '../../utils/constants';

const UserRefinementChoice = ({ data, handleOnClick, selectedDimensions }) => {
  const [selectedRefinement, setSelectedRefinement] = useState([]);
  const totalRefinements = data.reduce((sum, dimension) => sum + (dimension?.refinements?.length || 0), 0);
  const onRefinementClick = (dimensionWithRefinement) => {
    const { label, dimensionId, filterType, refinementLabel, refinementKey } = dimensionWithRefinement;
    setSelectedRefinement((prev) => {
      if (prev.includes(refinementKey)) {
        return prev.filter((key) => key !== refinementKey);
      }
      return [...prev, refinementKey];
    });
    if (handleOnClick) {
      const userRefinement = { label: refinementLabel, refinementKey, filterType };
      const userDimension = { label, dimensionId };
      handleOnClick({ setByUser: { userRefinement, userDimension }, defaultFilterSelection: false });
    }
  };


  useEffect(() => {
    const refinementKeys = selectedDimensions.flatMap((dimension) =>
      dimension.refinements.map((refinement) => refinement.refinementKey)
    );
    const uniqueRefinementKeys = [...new Set(refinementKeys)];
    setSelectedRefinement(uniqueRefinementKeys);
  }, [selectedDimensions]);

  return (
    <ErrorBoundary id="smart-filter-userRefinementChoice" name="smart-filter-userRefinementChoice">
      <div
        data-testid="smart-filter-user-refinement-choice"
        className="sui-flex-col sui-pt-4 xl:sui-flex sui-gap-2 sui-w-full"
      >
        <Typography weight="bold" variant="body-lg">{totalRefinements} Matching Filters Found</Typography>
        <Typography variant="body-base">select up to {CONSTANTS.REFINEMENTS_THRESHOLD}</Typography>
        {data && data.map(({ label, dimensionId, refinements }) => (
          <div key={dimensionId}>
            <div className="sui-mb-2 sui-mt-2">
              <Typography weight="bold" align="left">{label}:</Typography>
            </div>
            {refinements && refinements.map(({ refinementKey, filterType, label: refinementLabel }) => {
              const showConfirmedIcon = selectedRefinement.includes(refinementKey);
              return (
                <div className="sui-inline-block sui-mr-2 sui-mb-2" key={refinementKey}>
                  <Pill
                    label={refinementLabel}
                    onClick={() => onRefinementClick({ label, dimensionId, filterType, refinementLabel, refinementKey })}
                    variant={showConfirmedIcon ? 'filled' : 'outline'}
                  />
                </div>
              );
            }
            )}
          </div>
        ))}
      </div>
    </ErrorBoundary>
  );
};

UserRefinementChoice.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    dimensionKey: PropTypes.string,
    refinements: PropTypes.arrayOf(PropTypes.shape({
      refinementKey: PropTypes.string,
      label: PropTypes.string
    }))
  })),
  handleOnClick: PropTypes.func,
  selectedDimensions: PropTypes.arrayOf(PropTypes.shape({}))
};

UserRefinementChoice.defaultProps = {
  data: [],
  selectedDimensions: []
};

UserRefinementChoice.displayName = 'UserRefinementChoice';

export { UserRefinementChoice };
